const getYearsForSelect = () => {
    const years: number[] = [];
    for (let year = 2022; year <= new Date().getFullYear(); year++) {
        years.push(year);
    }
    return years;
};

export default getYearsForSelect;
